module.exports = __webpack_public_path__ + "img/anasayfa-urun-bg-big.c0e5f570.png";